<template>
	<v-select
		:items="[{value:null,text:'מדידה רגילה'},'MNS','HTM',{value:'TEKEN',text:'תקן'}]"
		v-model="model"
		v-bind="$attrs"
		label="MNS\HTM\תקן">
	</v-select>
</template>

<script>
	export default {
		name: "recheck-select",
		props: ["value"],
		components: {},
		data() {
			return {};
		},
		computed: {
			model: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			}
		}
	};
</script>

<style scoped>

</style>
